import Vue from 'vue'
import store from '../../store'
import {
  getCurrentClinic,
  getCurrentUser
} from '../../utils/localStorageManager'
import { v4 as uuidv4 } from 'uuid'

export default {
  channel(state) {
    if (state.channel) {
      return state.channel
    }
    const clinic = getCurrentClinic()

    const tabId = uuidv4()
    window.sessionStorage.setItem('tabId', tabId)

    const channel = Vue.prototype.pusher.subscribe(
      `clinic-${clinic.id}-tab-${window.sessionStorage.getItem('tabId')}`
    )
    // const channel = Vue.prototype.pusher.subscribe(`clinic-${clinic.id}`)
    store.dispatch('pusher/setChannel', channel, { root: true })
    return channel
  },

  /**
   * Canal do USUÁRIO (multiunidades v3, impl-07 §4).
   *
   * O canal por clínica não representa um relatório que consolida N unidades:
   * o arquivo é de quem pediu, não de uma unidade. O export de relatório
   * gerencial passou a ser publicado em `user-{id}-tab-{tabId}`.
   *
   * Fica ao lado do canal por clínica em vez de substituí-lo: o canal por
   * clínica carrega uma dúzia de outros eventos (documentos, lotes TISS,
   * impressão) que continuam sendo por clínica. Trocar o `channel` global
   * quebraria todos eles.
   *
   * Reaproveita o mesmo `tabId` da aba — é ele que dá entropia ao nome, e o
   * backend usa exatamente essa composição.
   */
  userChannel(state) {
    if (state.userChannel) {
      return state.userChannel
    }

    const user = getCurrentUser()

    if (!user?.id) {
      return null
    }

    // O `channel` acima é quem cria o tabId. Ler aqui sem garantir a criação
    // deixaria os dois canais com sufixos diferentes.
    let tabId = window.sessionStorage.getItem('tabId')
    if (!tabId) {
      tabId = uuidv4()
      window.sessionStorage.setItem('tabId', tabId)
    }

    const userChannel = Vue.prototype.pusher.subscribe(
      `user-${user.id}-tab-${tabId}`
    )
    store.dispatch('pusher/setUserChannel', userChannel, { root: true })
    return userChannel
  }
}
